import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { ToastContainer } from "react-toastify";
import { App } from "./App";
import { AuthContextProvider } from "./lib/context/Auth/AuthContextProvider";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./components/Login/authConfig";

import "./lib/scss/main.scss";
import "reactjs-popup/dist/index.css";
import "react-toastify/dist/ReactToastify.css";
import "react-loading-skeleton/dist/skeleton.css";

const msalInstance = new PublicClientApplication(msalConfig);
const rootElement = document.getElementById("root");

if (rootElement) {
  createRoot(rootElement).render(
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        <AuthContextProvider>
          <ToastContainer position="top-right" theme="colored" icon={false} />
          <App />
        </AuthContextProvider>
      </BrowserRouter>
    </MsalProvider>
  );
}
